import '../../style/base.css';
import '../../overlay/index.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../../popup/index.css';
import '../../loading/index.css';
import '../../button/index.css';
import '../../goods-action-button/index.css';
import '../../goods-action/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/dialog/style/index.js
// module id = 411
// module chunks = 0